<script lang="ts">
	import ArticleCard from "@components/ArticleCard.svelte";
	import HugeHeading from "@components/HugeHeading.svelte";
	import Formatted from "@components/common/Formatted.svelte";
	import Link from "@components/common/Link.svelte";
	import type { ClassValue } from "svelte/elements";
	import { ButtonVariant } from "@core/schema/ButtonVariant.js";
	import type { PublicArticle } from "@core/schema/PublicArticle.js";
	import { getBlogPath } from "@core/schema/paths/getBlogPath.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";

	const { articles, class: customClass }: { articles: PublicArticle[]; class?: ClassValue } = $props();

	const { tenant } = getGlobalTemplateProps();
</script>

<!--
	[&:is(*)] is used to overwrite full-width's styles by increasing specificity.
 	!important isn't suitable, as we accept `customClass` and thus padding should be overridable
-->
<section
	class={[
		customClass,
		"full-width flex flex-col max-w-[min(120rem,99dvw)] py-8 md:py-16 lg:py-20 place-self-center w-screen",
		" [&:is(&)]:px-[var(--container-gap)]",
	]}
>
	<div class="flex flex-col lg:flex-row lg:justify-between px-6 md:px-0 self-stretch">
		<HugeHeading level={2} text="Aktuality nl[[]] stroke[[ze světa mezi regály]]" />
		<div class="flex flex-col lg:gap-16 md:gap-12 gap-10 max-w-[37.25rem] pt-8 md:pt-12">
			<div class="md:text-[1.25rem]/[1.4] text-xs/[1.4] font-semibold [&_br]:hidden md:[&_br]:inline">
				<Formatted
					text="Přečtěte si novinky z Commarec,nl[[]] načerpejte logistickou inspiraci nebo nl[[]] zjistěte, co zajímavého se v oboru děje."
				/>
			</div>
			<Link
				href={getBlogPath(tenant)}
				variant={ButtonVariant.Outlined}
				class="md:inline-flex hidden gap-8 w-fit"
				icon="arrow"
			>
				<Formatted text="Všechny články" />
			</Link>
		</div>
	</div>
	<div
		class="flex gap-6 md:gap-8 flex-col justify-center items-center md:items-end md:justify-end 2xl:flex-row 2xl:mt-2 mt-8"
	>
		<div class="flex flex-col gap-1 md:gap-6 px-2">
			{#each articles as article (article.id)}
				<ArticleCard {article} class="min-w-[22.5rem] md:max-w-none 2xl:w-[77.3125rem] md:min-h-[20rem]" />
			{/each}
		</div>
		<Link href={getBlogPath(tenant)} variant={ButtonVariant.Outlined} icon="arrow" class="inline-flex md:hidden w-fit">
			<Formatted text="Všechny články" />
		</Link>
	</div>
</section>
